(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["account-drawer"] && !Shopify.designMode) return;
  try {
    const favoritesList = document.getElementById('favorites-list');
  const favoriteTemplate = document.getElementById('favorite-template');

  if (favoritesList && favoriteTemplate) {
    function renderFavorites() {
      const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
      favoritesList.replaceChildren(
        ...favorites.map((item) => {
          const clone = favoriteTemplate.content.cloneNode(true);
          clone.querySelector('[data-field="title"]').textContent = item.title;
          clone.querySelector('[data-field="price"]').textContent = item.price;
          clone.querySelector('[data-favorite-id]').dataset.favoriteId = item.id;
          const link = clone.querySelector('a');
          link.href = item.url;
          const img = clone.querySelector('img');
          img.src = item.image;
          img.alt = item.title;
          return clone;
        })
      );
    }

    favoritesList.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-favorite-id]');
      if (!btn) return;

      const stored = JSON.parse(localStorage.getItem('favorites') || '[]');
      const idx = stored.findIndex((f) => f.id === btn.dataset.favoriteId);
      if (idx > -1) stored.splice(idx, 1);
      localStorage.setItem('favorites', JSON.stringify(stored));
      renderFavorites();

      const productBtn = document.querySelector(`.product-favorite[data-product-id="${btn.dataset.favoriteId}"]`);
      if (productBtn) productBtn.setAttribute('aria-pressed', false);

      window.egToast?.success(btn.dataset.toastRemoved);
    });

    window.renderFavorites = renderFavorites;
    renderFavorites();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    document.querySelector('#filters-sidebar').addEventListener('change', (e) => {
    const checkbox = e.target;
    if (checkbox.type !== 'checkbox') return;
    const others = document.querySelectorAll(`#filters-sidebar input[type="checkbox"][name="${checkbox.name}"][value="${checkbox.value}"]`);
    others.forEach((other) => {
      if (other !== checkbox) other.checked = checkbox.checked;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-pagination"] && !Shopify.designMode) return;
  try {
    window.initCollectionPagination = function(gridSelector, gate) {
    var grid = document.querySelector(gridSelector);
    var more = grid && grid.querySelector('.collection-products__more');
    if (!more) return;
    var button = more.querySelector('.collection-products__load-more');
    gate = gate || 4;

    var loaded = 1; // first page is server-rendered
    var busy = false;

    var observer = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) trigger();
    }, { rootMargin: '0px 0px 400px 0px' });

    function showSkeletons() {
      var skeletons = [];
      for (var i = 0; i < 8; i++) {
        var el = document.createElement('div');
        el.className = 'collection-product-skeleton';
        el.innerHTML =
          '<div class="collection-product-skeleton__image"></div>' +
          '<div class="collection-product-skeleton__line"></div>' +
          '<div class="collection-product-skeleton__line collection-product-skeleton__line--short"></div>';
        grid.insertBefore(el, more);
        skeletons.push(el);
      }
      return skeletons;
    }

    async function load() {
      var nextUrl = more.dataset.nextUrl;
      if (!nextUrl) return 'done';
      delete more.dataset.nextUrl;
      var skeletons = showSkeletons();

      try {
        var res = await fetch(nextUrl);
        var html = await res.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector(gridSelector);
        var newMore = doc.querySelector('.collection-products__more');

        skeletons.forEach(function(s) { s.remove(); });

        if (newGrid) {
          Array.from(newGrid.children).forEach(function(item) {
            if (item.classList.contains('collection-products__more')) return;
            grid.insertBefore(item, more);
          });
        }

        if (newMore && newMore.dataset.nextUrl) {
          more.dataset.nextUrl = newMore.dataset.nextUrl;
          return 'more';
        }
        more.remove();
        return 'done';
      } catch (err) {
        skeletons.forEach(function(s) { s.remove(); });
        more.dataset.nextUrl = nextUrl;
        console.error('[collection-pagination] fetch failed:', err);
        return 'error';
      }
    }

    async function trigger() {
      if (busy || !more.dataset.nextUrl) return;
      busy = true;
      observer.unobserve(more);

      var status = await load();
      busy = false;

      if (status === 'done') return;
      if (status === 'error') { observer.observe(more); return; }

      loaded++;
      if (loaded % gate === 0) {
        button.hidden = false; // gate reached: wait for a click
      } else {
        observer.observe(more);
      }
    }

    button.addEventListener('click', function() {
      button.hidden = true;
      trigger();
    });

    observer.observe(more);
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('mouseover', (e) => {
    const swatch = e.target.closest('.collection-product__swatch[data-color-index]');
    if (!swatch) return;
    const card = swatch.closest('.collection-product');
    if (!card) return;
    const index = swatch.dataset.colorIndex;
    card.querySelectorAll('.collection-product__img--variant').forEach((img) => {
      img.classList.toggle('is-visible', img.dataset.colorIndex === index);
    });
  });

  document.addEventListener('mouseout', (e) => {
    const swatch = e.target.closest('.collection-product__swatch[data-color-index]');
    if (!swatch) return;
    swatch.closest('.collection-product')
      ?.querySelectorAll('.collection-product__img--variant.is-visible')
      .forEach((img) => img.classList.remove('is-visible'));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.product-gallery').forEach((gallery) => {
    const scroller = gallery.querySelector('.product-gallery__scroller');
    if (!scroller) return;

    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    const items = Array.from(scroller.children);

    const itemCenter = (item) => item.offsetLeft + item.offsetWidth / 2;
    const goToItem = (item) => {
      if (item) scroller.scrollTo({ left: itemCenter(item) - scroller.clientWidth / 2, behavior: 'smooth' });
    };

    // Advance to the next/previous snap point relative to the current viewport
    // center, so a click always moves one image even when several are visible.
    prev?.addEventListener('click', () => {
      const center = scroller.scrollLeft + scroller.clientWidth / 2;
      goToItem([...items].reverse().find((item) => itemCenter(item) < center - 1) || items[0]);
    });
    next?.addEventListener('click', () => {
      const center = scroller.scrollLeft + scroller.clientWidth / 2;
      goToItem(items.find((item) => itemCenter(item) > center + 1) || items[items.length - 1]);
    });

    const updateNav = () => {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      if (prev) prev.disabled = scroller.scrollLeft <= 1;
      if (next) next.disabled = scroller.scrollLeft >= maxScroll - 1;
    };

    scroller.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-lightbox"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('product-lightbox');
    if (!dialog) return;

    const mainEl = dialog.querySelector('.product-lightbox__main');
    const thumbsEl = dialog.querySelector('.product-lightbox__thumbs');
    const prevEl = dialog.querySelector('[data-lightbox-prev]');
    const nextEl = dialog.querySelector('[data-lightbox-next]');

    // Lazy-load the vendored Swiper bundle (CSS + JS) on first open only.
    let swiperReady;
    const loadSwiper = () => {
      if (swiperReady) return swiperReady;
      swiperReady = new Promise((resolve) => {
        const css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = dialog.dataset.swiperCss;
        document.head.appendChild(css);
        const js = document.createElement('script');
        js.src = dialog.dataset.swiperJs;
        js.onload = resolve;
        document.head.appendChild(js);
      });
      return swiperReady;
    };

    let mainSwiper;
    const initSwiper = () => {
      if (mainSwiper) return;
      const thumbsSwiper = new Swiper(thumbsEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        cssMode: true,
        watchSlidesProgress: true,
      });
      mainSwiper = new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: { prevEl, nextEl },
        thumbs: { swiper: thumbsSwiper },
        keyboard: { enabled: true },
      });
    };

    // While any slide is zoomed, hand pointer gestures to the slide's own
    // overflow scroll instead of swiping the carousel (arrows/thumbs still work).
    const syncTouch = () => {
      if (mainSwiper) mainSwiper.allowTouchMove = !mainEl.querySelector('.is-zoomed');
    };

    mainEl.addEventListener('click', (e) => {
      const img = e.target.closest('.swiper-slide img');
      if (!img) return;
      img.closest('.swiper-slide').classList.toggle('is-zoomed');
      syncTouch();
    });

    dialog.addEventListener('close', () => {
      mainEl.querySelectorAll('.is-zoomed').forEach((slide) => {
        slide.classList.remove('is-zoomed');
        slide.scrollTop = 0;
      });
      syncTouch();
    });

    const open = async (index) => {
      dialog.showModal();
      await loadSwiper();
      initSwiper();
      mainSwiper.update();
      mainSwiper.slideTo(index, 0);
    };

    const getImageName = (src) => (src ? src.split('?')[0].split('/').pop().split('.').slice(0, -1).join('.') : '');
    const slides = Array.from(mainEl.querySelectorAll('.swiper-slide'));
    const indexFor = (name) => slides.findIndex((s) => s.dataset.imageName === name);

    // Open from any hero gallery image (or the standalone bottom image).
    const layout = dialog.closest('body') || document;
    layout.addEventListener('click', (e) => {
      const img = e.target.closest('.product-gallery img, .product-bottom-image img');
      if (!img) return;
      const index = indexFor(getImageName(img.currentSrc || img.src));
      open(index < 0 ? 0 : index);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scripts"] && !Shopify.designMode) return;
  try {
    const CART_QTY_DEBOUNCE_MS = 350;
  const pendingCartQty = new Map();
  let cartQtyTimer = null;
  let cartQtyFlight = null;
  let cartQtyErrorMsg = null;

  async function flushCartQty() {
    clearTimeout(cartQtyTimer);
    cartQtyTimer = null;
    if (cartQtyFlight) await cartQtyFlight;
    if (pendingCartQty.size === 0) return;
    const updates = Array.from(pendingCartQty.entries());
    pendingCartQty.clear();
    cartQtyFlight = (async () => {
      let rejected = false;
      for (const [id, quantity] of updates) {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id, quantity }),
        });
        // Shopify returns 422 when the requested quantity exceeds available stock.
        if (!res.ok) rejected = true;
      }
      await window.refreshCart();
      if (rejected && cartQtyErrorMsg) window.egToast?.error?.(cartQtyErrorMsg);
    })();
    try { await cartQtyFlight; } finally { cartQtyFlight = null; }
  }

  window.queueCartQty = function(id, quantity, errorMsg) {
    if (errorMsg) cartQtyErrorMsg = errorMsg;
    pendingCartQty.set(id, quantity);
    clearTimeout(cartQtyTimer);
    cartQtyTimer = setTimeout(flushCartQty, CART_QTY_DEBOUNCE_MS);
  };

  window.flushCartQty = flushCartQty;

  window.refreshCart = async function() {
    const [sectionsRes, cartRes] = await Promise.all([
      fetch(`${window.location.pathname}?sections=cart-drawer`),
      fetch('/cart.js'),
    ]);
    const sections = await sectionsRes.json();
    const cart = await cartRes.json();

    const drawerWrapper = document.getElementById('shopify-section-cart-drawer');
    if (drawerWrapper && sections['cart-drawer']) {
      const wasOpen = document.getElementById('cart-drawer')?.open;
      drawerWrapper.outerHTML = sections['cart-drawer'];
      if (wasOpen) document.getElementById('cart-drawer')?.showModal();
    }

    const countEl = document.querySelector('[data-cart-count]');
    if (countEl) countEl.textContent = cart.item_count;
  }

  window.actions = {
  expandToggle: (el) => {
  const ariaExpanded = el.getAttribute('aria-expanded');
  if (!ariaExpanded) return;
  el.setAttribute('aria-expanded', ariaExpanded == 'true' ? 'false' : 'true');

  const ariaControls = el.getAttribute('aria-controls');
  if (!ariaControls) return;
  try {
  const target = document.getElementById(ariaControls)
  if(!target) return;
  target.toggleAttribute("inert")
  } catch(e) {}
  },
  openDialog: (el) => {
    const id = el.dataset.target;
    if (!id) return;
    const dialog = document.getElementById(id);
    if (!dialog) return;
    dialog.showModal();
  },
  closeDialogBackdrop: (el, e) => {
    if (!(el instanceof HTMLDialogElement)) return;
    const rect = el.getBoundingClientRect();
    if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) {
      el.close();
    }
  },
  openCart: () => {
    const dialog = document.getElementById('cart-drawer');
    if (dialog) dialog.showModal();
  },
  closeCart: () => {
    const dialog = document.getElementById('cart-drawer');
    if (dialog) dialog.close();
    flushCartQty();
  },
  removeCartItem: async (el) => {
    const id = el.dataset.variantId;
    if (!id) return;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 0 })
    });
    await refreshCart();
    window.egToast?.success(el.dataset.toastRemoved);
  },
  changeCartVariant: async (el) => {
    const line = el.closest('[data-line-item]');
    if (!line || line.hasAttribute('data-loading')) return;

    const variantsEl = line.querySelector('[data-line-variants]');
    if (!variantsEl) return;
    const variants = JSON.parse(variantsEl.textContent);

    const selected = [];
    line.querySelectorAll('[data-cart-option]').forEach((fs) => {
      const pos = parseInt(fs.dataset.optionPosition, 10) - 1;
      const checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) selected[pos] = checked.value;
    });

    // The combinations form a sparse matrix, so an exact match may not exist
    // (e.g. picking a texture that the current color doesn't come in). Fall back
    // to an available variant that at least carries the option just changed.
    const priorityIndex = parseInt(el.closest('[data-cart-option]')?.dataset.optionPosition, 10) - 1;
    const matchesAll = (v) => v.options.every((o, i) => o === selected[i]);
    const matchesPriority = (v) => v.options[priorityIndex] === selected[priorityIndex];
    const match =
      variants.find((v) => matchesAll(v) && v.available) ||
      variants.find(matchesAll) ||
      variants.find((v) => matchesPriority(v) && v.available) ||
      variants.find(matchesPriority);

    const oldId = line.dataset.variantId;
    if (!match || String(match.id) === String(oldId)) return;

    const unavailableMsg = line.querySelector('.drawer__variants')?.dataset.toastUnavailable;
    const lineIndex = Array.from(line.parentElement.children).indexOf(line);

    // Bail before clearing if the target can't be bought, so we never empty the cart on a 422.
    if (!match.available) {
      window.egToast?.error?.(unavailableMsg);
      return;
    }

    line.setAttribute('data-loading', '');
    await flushCartQty();

    // Shopify can't swap a variant in place, and since 2023-10 the cart is sorted
    // reverse-chronologically (last added sits on top). Rebuild it in its original
    // order with the edited line replaced — clear, then add.js with the items array
    // REVERSED so the first line is added last and ends up on top (merges dupes too).
    const cart = await (await fetch('/cart.js')).json();
    const items = cart.items.map((item, i) => {
      const entry = { id: i === lineIndex ? match.id : item.variant_id, quantity: item.quantity };
      if (item.properties && Object.keys(item.properties).length) entry.properties = item.properties;
      const sellingPlan = item.selling_plan_allocation?.selling_plan?.id;
      if (sellingPlan) entry.selling_plan = sellingPlan;
      return entry;
    });

    await fetch('/cart/clear.js', { method: 'POST' });
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items.reverse() }),
    });

    await refreshCart();
    if (!res.ok) window.egToast?.error?.(unavailableMsg);
  },
  updateCartQty: (el) => {
    const id = el.dataset.variantId;
    const quantity = parseInt(el.dataset.quantity, 10);
    if (!id || isNaN(quantity) || quantity < 0) return;

    const item = el.closest('.drawer__item');
    if (item) {
      const valueEl = item.querySelector('.drawer__qty-value');
      if (valueEl) valueEl.textContent = quantity;
      item.querySelectorAll('.drawer__qty-btn').forEach((btn, i) => {
        btn.dataset.quantity = i === 0 ? Math.max(0, quantity - 1) : quantity + 1;
      });
      if (quantity === 0) item.style.opacity = '0.5';
    }

    window.queueCartQty(id, quantity, el.dataset.toastUnavailable);
  },
  updateCartPageQty: async (el) => {
    const id = el.dataset.variantId;
    const quantity = parseInt(el.dataset.quantity, 10);
    if (!id || isNaN(quantity) || quantity < 0) return;
    el.disabled = true;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, quantity }),
    });
    if (quantity === 0 && el.dataset.toastRemoved) {
      window.egToast?.success(el.dataset.toastRemoved);
    }
    window.location.reload();
  },
  toggleMenu: () => {
    const menu = document.querySelector('.mobile-menu');
    if (!menu) return;
    if (menu.hasAttribute('inert')) {
      actions.openMenu();
    } else {
      actions.closeMenu();
    }
  },
  openMenu: () => {
    document.querySelectorAll('.filters-sidebar:not([inert])').forEach((sidebar) => {
      sidebar.setAttribute('inert', '');
    });
    const menu = document.querySelector('.mobile-menu');
    if (menu) menu.removeAttribute('inert');
  },
  closeMenu: () => {
    const menu = document.querySelector('.mobile-menu');
    if (!menu) return;
    menu.setAttribute('inert', '');
    actions.closeMobileSubmenus();
  },
  closeMobileSubmenus: () => {
    document.querySelectorAll('.mobile-menu button[aria-expanded="true"]').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.mobile-menu__submenu.is-visible').forEach((sub) => {
      sub.classList.remove('is-visible');
    });
  },
  toggleMobileSubmenu: (el) => {
    const wasOpen = el.getAttribute('aria-expanded') === 'true';
    actions.closeMobileSubmenus();
    if (!wasOpen) {
      el.setAttribute('aria-expanded', 'true');
      const submenu = document.querySelector(`.mobile-menu__submenu[data-submenu="${el.dataset.submenu}"]`);
      if (submenu) submenu.classList.add('is-visible');
    }
  },
  closeMobileFilterGroups: () => {
    document.querySelectorAll('.mobile-filters__item button[aria-expanded="true"]').forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.mobile-filters__group.is-visible').forEach((group) => {
      group.classList.remove('is-visible');
    });
  },
  toggleFilterGroup: (el) => {
    const wasOpen = el.getAttribute('aria-expanded') === 'true';
    el.setAttribute('aria-expanded', String(!wasOpen));
    const group = document.querySelector(`.mobile-filters__group[data-filter="${el.dataset.filter}"]`);
    if (group) group.classList.toggle('is-visible', !wasOpen);
  },
  closeSearch: () => {
    const header = document.querySelector('header');
    if (!header || !header.hasAttribute('data-search-open')) return;
    header.removeAttribute('data-search-open');
    const overlay = header.querySelector('.search-overlay');
    if (overlay) overlay.setAttribute('inert', '');
  },
  closeModal: (el) => {
    const modal = el.closest('[aria-modal], [data-modal]');
    if (!modal) return;
    if (modal instanceof HTMLDialogElement) {
      modal.close();
      return;
    }
    modal.setAttribute('inert', '');
    if (modal.classList.contains('filters-sidebar')) actions.closeMobileFilterGroups();
    if (!modal.id) return;
    document.querySelectorAll(`[aria-controls="${modal.id}"][aria-expanded], [data-controls="${modal.id}"][aria-expanded]`)
      .forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
  },
  };

    document.addEventListener('click', (e) => {
      const target = e.target.closest('[data-action]');
      if (!target) return;

      for (const part of target.dataset.action.split(';')) {
        const [event, fn] = part.trim().split(':');
        if (event === 'click' && typeof actions[fn] === 'function') {
          actions[fn](target, e);
        }
      }
    });

    document.addEventListener('click', (e) => {
      if (e.target.closest('.drawer__checkout')) flushCartQty();
    }, true);

    document.addEventListener('close', (e) => {
      if (e.target.id === 'cart-drawer') flushCartQty();
    }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-images"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.scroll-images').forEach((el) => {
    const wrapper = el.querySelector('.scroll-images__wrapper');
    if (!wrapper) return;

    const aspectMode = el.classList.contains('scroll-images--aspect-ratio');
    const mobileQuery = window.matchMedia('(max-width: 47.999rem)');

    function syncHeight() {
      if (!aspectMode || mobileQuery.matches) {
        el.style.removeProperty('block-size');
        return;
      }
      const overflow = Math.max(0, wrapper.scrollWidth - wrapper.clientWidth);
      el.style.blockSize = (wrapper.clientHeight + overflow) + 'px';
    }

    syncHeight();

    let maxTranslate = (wrapper.scrollWidth - wrapper.clientWidth) / wrapper.clientWidth * 100;
    let scrollable = el.offsetHeight - window.innerHeight;

    function onScroll() {
      if (scrollable <= 0) return;
      const scrolled = Math.max(0, Math.min(-el.getBoundingClientRect().top, scrollable));
      const naturalPct = (scrolled / scrollable) * maxTranslate;

      if (el.dataset.variantLocked === 'true') {
        const lockedPct = parseFloat(el.dataset.lockedPct || '0');
        if (naturalPct > lockedPct) return;
        delete el.dataset.variantLocked;
        delete el.dataset.lockedPct;
      }

      wrapper.style.transform = `translateX(-${naturalPct}%)`;
    }

    window.addEventListener('resize', () => {
      syncHeight();
      maxTranslate = (wrapper.scrollWidth - wrapper.clientWidth) / wrapper.clientWidth * 100;
      scrollable = el.offsetHeight - window.innerHeight;
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["toasts"] && !Shopify.designMode) return;
  try {
    (function () {
    const container = document.querySelector('.toasts');
    const template = document.getElementById('toast-template');
    if (!container || !template) return;

    const DEFAULT_DURATION = 4000;
    const ANIMATION_MS = 280;
    const OUT_CLASS = 'toasts__item--out';

    let current = null;
    let hideTimer = null;
    let removeTimer = null;

    const clearTimers = () => {
      clearTimeout(hideTimer);
      clearTimeout(removeTimer);
    };

    const remove = (node) => {
      if (node && node.parentNode) node.parentNode.removeChild(node);
      if (current === node) current = null;
    };

    const dismiss = (node) => {
      if (!node) return;
      clearTimers();
      node.classList.add(OUT_CLASS);
      removeTimer = setTimeout(() => remove(node), ANIMATION_MS);
    };

    const show = (variant, text, options) => {
      const opts = options || {};
      const duration = typeof opts.duration === 'number' ? opts.duration : DEFAULT_DURATION;

      if (current) {
        clearTimers();
        remove(current);
      }

      const node = template.content.firstElementChild.cloneNode(true);
      node.dataset.variant = variant;
      node.setAttribute('role', variant === 'error' ? 'alert' : 'status');
      node.querySelector('.toasts__text').textContent = String(text);
      node.querySelector('.toasts__close').addEventListener('click', () => dismiss(node));

      const progress = node.querySelector('.toasts__progress');
      if (duration > 0) {
        progress.style.setProperty('--toast-duration', duration + 'ms');
        progress.hidden = false;
      }

      container.appendChild(node);
      current = node;

      // Flush the initial (offscreen) styles so the browser sees a state
      // change when we remove the class, and runs the enter transition.
      getComputedStyle(node).transform;
      node.classList.remove(OUT_CLASS);

      if (duration > 0) {
        hideTimer = setTimeout(() => dismiss(node), duration);
      }

      return {
        dismiss: () => dismiss(node),
      };
    };

    window.egToast = {
      info: (text, options) => show('info', text, options),
      success: (text, options) => show('success', text, options),
      error: (text, options) => show('error', text, options),
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
